import type { ChangeEvent, SyntheticEvent } from 'react';

export enum SyncConfigurationEntityType {
  Merchant = 'merchant',
  Store = 'store',
  Device = 'device',
}

export interface SyncConfigurationEntityOption {
  readonly label: string;
  readonly value: SyncConfigurationEntityType;
}

export interface UseSyncConfigurationPageContentReturn {
  readonly entityOptions: SyncConfigurationEntityOption[];
  readonly selectedEntity: SyncConfigurationEntityOption | null;
  readonly handleEntityChange: (event: SyntheticEvent, value: SyncConfigurationEntityOption | null) => void;
  readonly idsSectionTitle: string;
  readonly isDeviceEntitySelected: boolean;
  readonly singleId: string;
  readonly handleSingleIdChange: (event: ChangeEvent<HTMLInputElement>, inputName: string, value: unknown) => void;
  readonly deviceIds: string[];
  readonly handleDeviceIdsChange: (event: SyntheticEvent, value: string[]) => void;
  readonly isTriggerActionDisabled: boolean;
  readonly handleTriggerAction: () => void;
}
